import { z } from 'zod';

/** `GET /health/live` — the process is up (api-design §3.1). */
export const healthLiveResponseSchema = z.object({
  status: z.literal('ok'),
});

/** `GET /health/ready` — every dependency answered (200) or at least one did not (503). */
export const healthReadyResponseSchema = z.object({
  status: z.enum(['ok', 'unavailable']),
  checks: z.record(z.string(), z.enum(['ok', 'failed'])),
});

/** `GET /site` — what this site is, before anyone signs in (D49: the public demo signs in by itself). */
export const siteResponseSchema = z.object({
  demo: z.boolean(),
});

export type HealthLiveResponse = z.infer<typeof healthLiveResponseSchema>;
export type HealthReadyResponse = z.infer<typeof healthReadyResponseSchema>;
export type SiteResponse = z.infer<typeof siteResponseSchema>;
